import { render } from "./TodoListTask.vue?vue&type=template&id=e3477b26"
import script from "./TodoListTask.vue?vue&type=script&lang=js"
export * from "./TodoListTask.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__